// extracted by mini-css-extract-plugin
export default {"editableCell":"EditableCell_editableCell__2RhKm"};